import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

import { useStore } from "@/stores";
import { API_BIS_REPORT_STAT } from "@/configs/Apis";
import DuduAjax from "@/utils/DuduAjax";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsPreview',
  setup(__props) {

const store = useStore();

const queryType = ref("0");

const projectId = computed(() => (store.state as any).project.info.id);

const statRequestParams = () => ({
  rowDims: [{ name: "legalStatus", label: "法律状态", limit: 20, needTotal: true }],
  colDims: [{ name: "patentType", label: "专利类型", limit: 20, needTotal: true }],
  measures: [{ name: "count", label: "申请量", minValue: 0 }],
  condition: { items: [], relation: "" },
});

const requests: { [K: string]: any } = {
  basic: {
    api: { url: API_BIS_REPORT_STAT, path: {} },
    loading: ref(false),
    callback: (data: any, config: any) => {
      config.data = data;
    },
    params: statRequestParams,
    data: {},
  },
  validPatents: {
    api: { url: API_BIS_REPORT_STAT, path: {} },
    loading: ref(false),
    callback: (data: any, config: any) => {
      config.data = data;
    },
    params: statRequestParams,
    data: {},
  },
  allPatents: {
    api: { url: API_BIS_REPORT_STAT, path: {} },
    loading: ref(false),
    callback: (data: any, config: any) => {
      config.data = data;
    },
    params: statRequestParams,
    data: {},
  },
  inventPatents: {
    api: { url: API_BIS_REPORT_STAT, path: {} },
    loading: ref(false),
    callback: (data: any, config: any) => {
      config.data = data;
    },
    params: statRequestParams,
    data: {},
  },
};

const processRequestData = () => {
  Object.keys(requests).forEach(async (name) => {
    const config = requests[name];
    try {
      if (config.once === true && config.__loaded === true) {
        return;
      }
      config.loading.value = true;
      const params = typeof config.params === "function" ? config.params() : config.params;
      if (!Object.prototype.hasOwnProperty.call(config.api.path, "projectId")) {
        config.api.path.projectId = projectId.value;
      }
      const res = await DuduAjax.queryData(config.api, params, "POST", false, false);
      if (config.callback && typeof config.callback === "function") {
        config.callback(res, config);
      }
    } finally {
      config.loading.value = false;
      if (config.once === true) {
        config.__loaded = true;
      }
    }
  });
};

return { __sfc: true,store, queryType, projectId, statRequestParams, requests, processRequestData }
}

})